import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";


interface Props {
  name: string;
  label: string;
  value: Date | string | null;
  onChangeValue: (value: string | Date | null) => void;
  helperText?: string;
  error?: boolean;
  onBlur?: () => void;
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  tipoData?: ('meses' | 'mes' | 'ano' | 'completo');
  views?: ('year' | 'month' | 'day')[]
}

const onTipoData = (tipo: string) => {
  switch (tipo) {
    case 'meses':
      return "MMMM";
    case 'mes':
      return "MM/YYYY";
    case 'ano':
      return "YYYY";
    case 'completo':
      return "DD/MM/YYYY";
    default:
      return "DD/MM/YYYY";
  }
};

export const DefaultDatePicker = ({
  name,
  label,
  value,
  onChangeValue,
  helperText,
  error,
  onBlur,
  required,
  readOnly,
  disabled,
  views = ['day', 'month', 'year'],
  tipoData = 'completo'
}: Props) => {

  return (
    <DatePicker
      label={label}
      views={views}
      format={onTipoData(tipoData)}
      readOnly={readOnly}
      disabled={disabled}
      value={value ? dayjs(value) : null}
      onChange={(newValue: Dayjs | null) => {
        onChangeValue(newValue ? newValue.toDate() : null);
      }}
      slotProps={{
        field: {
          clearable: true,
          onClear: () => onChangeValue(null),
        },
        textField: {
          id: `input-${name}`,
          name: name,
          size: 'small',
          fullWidth: true,
          required: required,
          error: error,
          helperText: helperText,
          onBlur: onBlur,
        },
      }}
    />
  );
}